<template>
  <!-- 零售列表-周期购预计发货时间修改 -->
  <div class='cus-modal' v-loading='loading'>
    <OmsForm :form-config='formConfig' />
    <OmsButton :class="['modal-footer']" :btn-config='btnConfig' />
  </div>
</template>

<script>
export default {
  components: {},
  name: 'cycleUpdateEstimateConTime',
  props: ['componentData'],
  data() {
    return {
      loading: false,
      formConfig: {
        formValue: {
          estimateConTime: ''
        },
        formData: [
          {
            style: 'date',
            type: 'datetime', // 日期组件类型,默认为data  (daterange)为双日期区间选择
            value: 'estimateConTime',
            label: t('预计发货时间'),
            width: '24',
            format: 'yyyy-MM-dd HH:mm:ss', // 格式参照burgeonui
            placeholder: t('请选择')
            /* options: {
              disabledDate(date) {
                return date && date.valueOf() < Date.now();
              }
            } */
          }
        ],
        ruleValidate: {
          estimateConTime: [{ required: true, message: ' ', trigger: 'blur' }]
        }
      },
      btnConfig: {
        typeAll: 'default',
        btnsite: 'right',
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }
          },
          {
            type: 'primary', // 按钮类型
            text: t('确定'),
            btnclick: () => {
              this.confirmChange();
            }
          }
        ]
      }
    };
  },
  computed: {
    ids() {
      return this.componentData.ids;
    }
  },
  methods: {
    // 确定请求
    async confirmInfo(data) {
      this.loading = true;
      try {
        const res = await this.service.orderCenter.updatePreDeliveryTime(data);
        if (res.data.code === 0) {
          this.$Message.success(res.data.message);
          this.$parent.$parent.closeConfirm();
          this.$nextTick(() => {
            this.$parent.$parent.$parent.loadData();
          });
        } else {
          $fcError(res.data.message);
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }

    },
    confirmChange() {
      const time = this.formConfig.formValue.estimateConTime;
      if (!time || time.valueOf() < Date.now()) {
        $fcError(t('请输入正确的预计发货时间！'));
        return;
      }
      const param = {
        orderIds: this.ids,
        estimateConTime: $utils.dateFormat(time, 'yyyy-MM-dd hh:mm:ss')
      };
      this.confirmInfo(param);
    }
  },
  mounted() {
  }
};
</script>

<style lang='less' scoped>
@import '~@/css/modal/orderCenter/holdOrderDialog.less';
</style>
